import { c as _c } from "react/compiler-runtime";
import React from "react";
import CreateDropMetadataRow from "./CreateDropMetadataRow";
import type { CreateDropMetadataType } from "./CreateDropContent";
import { Tooltip } from "react-tooltip";
interface CreateDropMetadataProps {
  readonly metadata: CreateDropMetadataType[];
  readonly missingRequiredMetadataKeys: string[];
  readonly metadataErrorById: Readonly<Record<string, string>>;
  readonly disabled: boolean;
  readonly closeMetadata: () => void;
  readonly onChangeKey: (params: {
    index: number;
    newKey: string;
  }) => void;
  readonly onChangeValue: (params: {
    index: number;
    newValue: string | number | null;
  }) => void;
  readonly onAddMetadata: () => void;
  readonly onRemoveMetadata: (index: number) => void;
}
const CreateDropMetadata: React.FC<CreateDropMetadataProps> = t0 => {
  const $ = _c(34);
  const {
    metadata,
    missingRequiredMetadataKeys,
    metadataErrorById,
    closeMetadata,
    disabled,
    onChangeKey,
    onChangeValue,
    onAddMetadata,
    onRemoveMetadata
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span><span className="tw-text-xs tw-text-iron-300">Add Metadata</span></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-5 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== closeMetadata) {
    t3 = <button type="button" onClick={closeMetadata} className="-tw-mr-2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-50" data-tooltip-id="close-metadata">{t2}</button>;
    $[2] = closeMetadata;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Tooltip id="close-metadata" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>Close</Tooltip>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="tw-inline-flex tw-w-full tw-items-center tw-justify-between">{t1}<>{t3}{t4}</></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== disabled || $[8] !== metadata || $[9] !== metadataErrorById || $[10] !== missingRequiredMetadataKeys || $[11] !== onChangeKey || $[12] !== onChangeValue || $[13] !== onRemoveMetadata) {
    let t7;
    if ($[15] !== disabled || $[16] !== metadataErrorById || $[17] !== missingRequiredMetadataKeys || $[18] !== onChangeKey || $[19] !== onChangeValue || $[20] !== onRemoveMetadata) {
      t7 = (item, index) => <CreateDropMetadataRow key={item.id} isError={missingRequiredMetadataKeys.includes(item.key) || !!metadataErrorById[item.id]} errorMessage={metadataErrorById[item.id] ?? null} onRemove={onRemoveMetadata} metadata={item} index={index} onChangeKey={onChangeKey} onChangeValue={onChangeValue} disabled={disabled} />;
      $[15] = disabled;
      $[16] = metadataErrorById;
      $[17] = missingRequiredMetadataKeys;
      $[18] = onChangeKey;
      $[19] = onChangeValue;
      $[20] = onRemoveMetadata;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t6 = metadata.map(t7);
    $[7] = disabled;
    $[8] = metadata;
    $[9] = metadataErrorById;
    $[10] = missingRequiredMetadataKeys;
    $[11] = onChangeKey;
    $[12] = onChangeValue;
    $[13] = onRemoveMetadata;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[22] !== t6) {
    t7 = <div className="tw-space-y-2">{t6}</div>;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = `tw-flex tw-items-center tw-gap-x-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-sm tw-font-medium tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-primary-300 ${disabled ? "tw-cursor-default tw-opacity-50" : ""}`;
  let t10;
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className="tw-size-5 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>;
    t10 = <span>Add new</span>;
    $[24] = t10;
    $[25] = t9;
  } else {
    t10 = $[24];
    t9 = $[25];
  }
  let t11;
  if ($[26] !== disabled || $[27] !== onAddMetadata || $[28] !== t8) {
    t11 = <button type="button" onClick={onAddMetadata} disabled={disabled} className={t8}>{t9}{t10}</button>;
    $[26] = disabled;
    $[27] = onAddMetadata;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t5 || $[32] !== t7) {
    t12 = <div className="tw-mt-2 tw-space-y-2">{t5}{t7}{t11}</div>;
    $[30] = t11;
    $[31] = t5;
    $[32] = t7;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export default CreateDropMetadata;